import { PickType } from '@nestjs/swagger';
import { ModelBoardFloorDto } from './model-board-floor.dto';
import { ModelBoardFloorCreatableInterface } from '../interfaces/model-board-floor-creatable.interface';

export class ModelBoardFloorCreateDto
  extends PickType(ModelBoardFloorDto, [
    'boardTypeId',
    'quantity',
    'floor',
    'modelId',
    'phaseId',
  ])
  implements ModelBoardFloorCreatableInterface {}
